import styled from "styled-components"
import { shade } from "polished"

export const Container = styled.div`
  > header {
    height: 144px;
    background: #4169e1;

    display: flex;
    align-items: center;

    div {
      width: 100%;
      max-width: 1120px;
      margin: 0 auto;

      svg {
        color: white;
        width: 30px;
        height: 30px;
      }
    }
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: -150px auto 0;

  width: 100%;

  form {
    margin: 50px 0;
    width: 340px;
    display: flex;
    flex-direction: column;
    text-align: center;

    h1 {
      margin-bottom: 24px;
      font-size: 20px;
      text-align: left;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }
`

// export const AvatarInput = styled.div`
//   margin-bottom: 32px;
//   position: relative;
//   align-self: center;

//   img {
//     width: 186px;
//     height: 186px;
//     border-radius: 50%;
//   }

//   label {
//     position: absolute;
//     width: 48px;
//     height: 48px;
//     background: #00d5ee;
//     border-radius: 50%;
//     right: 0;
//     bottom: 0;
//     border: 0;
//     transition: background-color 0.2s;
//     cursor: pointer;

//     display: flex;
//     align-items: center;
//     justify-content: center;

//     input {
//       display: none;
//     }

//     svg {
//       width: 20px;
//       height: 20px;
//       color: white;
//     }

//     &:hover {
//       background: ${shade(0.2, "#00d5ee")};
//     }
//   }
//`
